/*
 * Keeps personalised boxes intact in the cart.
 *
 * Box lines share a `_box_id` line item property. Removing the box header line
 * has to remove its contents too, so we intercept that click before Dawn's own
 * `cart-remove-button` handler runs and issue a single /cart/update.js call.
 */
(function () {
  const readCart = () =>
    fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(
      (response) => response.json()
    );

  const linesFor = (cart, boxId) =>
    (cart.items || []).filter((item) => item.properties && item.properties._box_id === boxId);

  async function removeBox(boxId, trigger) {
    trigger.classList.add('loading');

    const drawer = document.querySelector('cart-drawer');
    const inDrawer = Boolean(trigger.closest('cart-drawer'));
    const sectionsPayload = {};

    if (inDrawer && drawer) {
      sectionsPayload.sections = drawer.getSectionsToRender().map((section) => section.id);
      sectionsPayload.sections_url = window.location.pathname;
    }

    const post = (url, body) =>
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then((response) => response.json());

    try {
      // Read the keys back from the cart instead of trusting the ones rendered
      // into the markup: an automatic discount on the box contents is
      // reallocated whenever the cart changes, and Shopify rewrites the `key`
      // of every line it touches. A stale key makes /cart/update.js fall back
      // to matching by variant id, which can take out another box's line.
      let cart = await readCart();
      let data = null;
      const keys = linesFor(cart, boxId).map((line) => line.key);

      if (!keys.length) {
        trigger.classList.remove('loading');
        return;
      }

      const updates = {};
      keys.forEach((key) => {
        updates[key] = 0;
      });
      data = await post(`${window.routes.cart_update_url}.js`, Object.assign({ updates }, sectionsPayload));

      // Removing one line can rewrite the keys of the ones left, so a single
      // batch may leave stragglers. Drop them one at a time.
      for (let guard = 0; guard < 20; guard += 1) {
        cart = data && data.items ? data : await readCart();
        const line = linesFor(cart, boxId)[0];
        if (!line) break;
        data = await post(
          `${window.routes.cart_change_url}.js`,
          Object.assign({ id: line.key, quantity: 0 }, sectionsPayload)
        );
      }

      if (inDrawer && drawer && data && data.sections) {
        drawer.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-box-cart', cartData: data });
        }
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      window.location.reload();
    } finally {
      trigger.classList.remove('loading');
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('cart-remove-button[data-box-remove]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      removeBox(trigger.dataset.boxRemove, trigger);
    },
    true
  );
})();
